import React from 'react';
import styled from 'styled-components';

import { Text } from 'core/ui/atoms';

const SlideText = styled((p) => <Text {...p} />)`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.01em;
  color: ${(p) => p.theme.colors.black};
  margin: 0;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.1);
  ${(p) => p.theme.max('sm')`
    line-height: 21px;
    max-width: 100vw;
    padding: 0 15px;
  `};
`;

export default SlideText;
